module.exports = __webpack_public_path__ + "img/rockestate_logo_aligned.bc7a4579.svg";